/* eslint-disable import/no-extraneous-dependencies, react/forbid-prop-types, react/require-default-props */
import PropTypes from 'prop-types'
import React from 'react'
import { css, StyleSheet } from 'aphrodite/no-important'

import defaults from 'react-images/lib/theme'
import deepMerge from 'react-images/lib/utils/deepMerge'
import Icon from 'react-images/lib/components/Icon'

const defaultStyles = {
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    height: defaults.header.height,
  },
  close: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    outline: 'none',
    position: 'relative',
    top: 0,
    verticalAlign: 'bottom',
    zIndex: 1,
    height: 40,
    marginRight: -10,
    padding: 10,
    width: 40,
  },
}

export default function Header({
  customControls,
  onClose,
  showCloseButton,
  closeButtonTitle,
  ...props
}) {
  const classes = StyleSheet.create(deepMerge(defaultStyles, {}))

  return (
    <div className={css(classes.header)} {...props}>
      {customControls || <span />}
      {!!showCloseButton && (
        <button
          title={closeButtonTitle}
          className={css(classes.close)}
          onClick={onClose}
        >
          <Icon fill={defaults.close.fill} type="close" />
        </button>
      )}
    </div>
  )
}

Header.propTypes = {
  closeButtonTitle: PropTypes.string,
  customControls: PropTypes.array,
  onClose: PropTypes.func.isRequired,
  showCloseButton: PropTypes.bool,
}
